import { render, staticRenderFns } from "./MeetingChatBox.vue?vue&type=template&id=80aea884&"
import script from "./MeetingChatBox.vue?vue&type=script&lang=js&"
export * from "./MeetingChatBox.vue?vue&type=script&lang=js&"
import style0 from "./MeetingChatBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VIcon,VProgressCircular})
